<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <ul>
      <li v-for="service in recurrentServices" :key="service.id" class='service-item' v-bind:class="{'deactivated-service-item': date_is_past(service.activeto)}">
        <div class='service-item-type service-icon' v-bind:class="{
            'icon-internet': service.type == 'internet',
            'icon-telefon': service.type == 'telefon',
            'icon-televize': service.type == 'televize',
            'icon-contract': service.type == 'pronájem/zápůjčka',
          }">
        </div>
        <div class='service-item-meat'>
          <br/>
          <span v-if="service.techtype == 71">
            Tarif:
          </span>
          <span v-else>
            Služba:
          </span>
          <span class='service-item-highlight'><b>{{ service.service_name }}</b></span>
          <span v-if="service.phone_number">číslo: <span class='service-item-highlight'>{{service.phone_number}}</span></span>
          <br>
          <span v-if="service.value !== null">
            Cena:
            <span v-if="service.vdiscount1>0 || (service.vdiscount2>0 && discount2ValidToDate(service))">
              <span class='price-before-discount'>{{ service.value }}</span>
              <span class='service-item-highlight'>
                <b>{{ (service.value - service.vdiscount1 - discount2ValueToday(service)).toFixed(2) }}</b> Kč
              </span>
              <i v-if="service.vdiscount1>0">
                (sleva {{prachy(service.vdiscount1)}} Kč)
              </i>
              <i v-if="(service.vdiscount2>0 && discount2ValidToDate(service))">
                (sleva {{prachy(service.vdiscount2)}} Kč<span v-if="service.vdiscount2_end_date"> do {{human_readable_date(service.vdiscount2_end_date)}}</span>)
              </i>
            </span>
            <span v-else>
              <span class='service-item-highlight'>
                <b>{{ prachy(service.value) }}</b> Kč
              </span>
            </span>
            {{ ({3:'měsíčně', 4:'čtvrtletně', 5: 'ročně', 7: 'půlročně'})[service.period] }}
            <span class="vat-text">
              {{ ({INCL:'včetně DPH', EXCL:'bez DPH', NONE: ''})[service.vat_type] }}
              <span v-if="service.vat_type != 'NONE'">{{ service.vat_rate }}%</span>
            </span>
            <br>
          </span>
          Lokalita:
          <span class='service-item-highlight'>{{ human_readable_adr(service)  }}</span>
          <span v-if="service.activefrom || service.activeto">
            <br>
            Aktivní
            <span v-if="service.activefrom"> od <span class='service-item-highlight'>{{ human_readable_date(service.activefrom) }}</span></span>
            <span v-if="service.activeto" v-bind:class="{'yellow-highlight': date_within_month(service.activeto)}"> do <span class='service-item-highlight'>{{ human_readable_date(service.activeto) }}</span></span>
          </span>
          <span v-if="(service.billingfrom || service.billingto) && (service.billingfrom != service.activefrom || service.billingto != service.activeto)">
            <br>
            Účtováno
            <span v-if="service.billingfrom"> od <span class='service-item-highlight'>{{ human_readable_date(service.billingfrom) }}</span></span>
            <span v-if="service.billingto"> do <span class='service-item-highlight'>{{ human_readable_date(service.billingto) }}</span></span>
          </span>
          <br>
          <span class='zpusob-uctovani' v-bind:class="{'uctovani-pozastaveno': service.suspended}">
            Způsob účtování:
            <span class='service-item-highlight'>{{ service.billingplan_name }}</span>
            <i>({{ service.billingplan_description }})</i>
            <span v-if="service.billingplan_with_invoice">+ vystavit fakturu</span>
            <span v-if="service.note">
              <br>
              Poznámka: {{ service.note }}
            </span>
          </span>
          <div class="alert alert-info" role="alert" v-if="service.type == 'televize' && service.techtype == 76 && service.kukiid && !date_is_past(service.activeto)">
            <!-- Kuki TV - zobrazeni ID a hesla -->
            Kuki ID: <span class='service-item-highlight'>{{ service.kukiid }}</span><br>
            Heslo: <span class='service-item-highlight'>{{ service.kukipassword }}</span>
          </div>
          <div class="alert alert-info" role="alert" v-if="service.type == 'telefon' && service.techtype == 75">
            <!-- IPEX - odkazy na podrobnej vypis hovoru -->
            <ipex-cdrfiles-links :number="service.phone_number" />
          </div>
          <div class="alert alert-danger" role="alert" v-if="service.suspended">
            služba je dočasně pozastavena
          </div>
        </div>
      </li>
    </ul>

    <section v-if="onetimeServices && onetimeServices.length">
      <p>JEDNORÁZOVÉ SLUŽBY</p>
      <table class="table">
        <thead>
          <tr>
            <th>
              datum
            </th>
            <th class="money">
              cena
            </th>
            <th width="75%">
              popis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="os in onetimeServices" :key="os.id">
            <td>
              {{ human_readable_date(os.activefrom) }}
            </td>
            <td class="money">
              <span v-if="os.value !== null">
                <div>{{ prachy(os.value) }} Kč</div>
                <div>{{ ({INCL:'včetně DPH', EXCL:'bez DPH', NONE: ''})[os.vat_type] }}</div>
              </span>
              <span v-else>
                -
              </span>
            </td>
            <td>
              <div class='service-item-highlight'>{{ os.service_name }}</div>
              <div>{{ os.note }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section v-if="recurrentServices !== null && recurrentServices.length == 0 && onetimeServices !== null && onetimeServices.length == 0">
      <div class="alert alert-info" role="alert">
        žádné služby
      </div>
    </section>
  </section>
</template>

<script>
import AssignmentResource from '../backend-resources/assignment-resource'
import moment from 'moment'
import IpexCdrFilesLinks from '@/components/IpexCdrFilesLinks'

export default {
  data () {
    return {
      recurrentServices: null,
      onetimeServices: null,
      displayError: null,
      isLoading: false
    }
  },
  components: {
    'ipex-cdrfiles-links': IpexCdrFilesLinks
  },
  created: function () {
    this.loadServices()
  },
  methods: {
    loadServices: function () {
      this.isLoading = true
      AssignmentResource.get().then((services) => {
        this.onetimeServices = services.data.onetime
        this.recurrentServices = services.data.recurrent
        this.displayError = null
        this.isLoading = false
      }).catch((error) => {
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.onetimeServices = null
        this.recurrentServices = null
        this.isLoading = false
        if (error.response.status === 401) {
          this.$router.push('/login')
        }
      })
    },
    human_readable_adr: function (si) {
      let address = si.adr_note ? (si.adr_note + ', ') : ''
      address += si.adr_ulice ? si.adr_ulice : si.adr_obec
      address += ' ' + si.adr_cislo
      address += ', ' + si.adr_obec
      if (si.adr_cobce && si.adr_cobce !== si.adr_obec) {
        address += ' - ' + si.adr_cobce
      }
      return address
    },
    human_readable_date: function (yyyymmdd) {
      return moment(yyyymmdd).format('D.M.Y')
    },
    prachy: function (kolik) {
      if (kolik === null) {
        return ''
      }
      kolik = parseFloat(kolik)
      return kolik.toFixed(2)
    },
    date_is_past: function (yyyymmdd) {
      if (yyyymmdd === '') return false
      return moment(yyyymmdd) < moment().subtract(1, 'day')
    },
    date_within_month: function (yyyymmdd) {
      if (yyyymmdd === '') return false
      if (this.date_is_past(yyyymmdd)) return false
      return moment(yyyymmdd).add(1, 'month') > moment()
    },
    discount2ValidToDate: function (service) {
      return service.vdiscount2_end_date === null || !this.date_is_past(service.vdiscount2_end_date)
    },
    discount2ValueToday: function (service) {
      if (this.discount2ValidToDate(service)) {
        return service.vdiscount2
      } else {
        return 0
      }
    }
  }
}
</script>
<style scoped>
li.service-item {
  margin-bottom: 20px;
  list-style: none;
  border-style: solid;
  border-width: 1px;
  border-color: #e7e7e7;
  border-radius: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.deactivated-service-item {
  opacity: 0.33;
}
.service-item-highlight {
  color:#538ebe;
}
.yellow-highlight {
  background-color: yellow;
}
.price-before-discount {
  color: gray;
  text-decoration: line-through;
}
.vat-text {
  color: gray;
}
.service-icon {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 5px;
  width: 54px;
  height: 62px;
  padding-top: 42px;
  float: left;
}
.icon-internet {
  background: url(/static/free-icons/network-cable-icon-15497.png) -0px -0px no-repeat;
  background-size: 100%;
}
.icon-telefon {
  background: url(/static/free-icons/phone-icon-922.png) -0px -0px no-repeat;
  background-size: 100%;
}
.icon-televize {
  background: url(/static/free-icons/television-icon-22221.png) -0px -0px no-repeat;
  background-size: 100%;
}
.icon-contract {
  background: url(/static/free-icons/contract-icon-19930.png) -0px -0px no-repeat;
  background-size: 100%;
}

.service-item-meat {
  margin-left: 95px;
}
ul {
  padding-left: 0;
  margin-left: 0;
}
.zpusob-uctovani .uctovani-pozastaveno {
  text-decoration: line-through;
}
.money {
  text-align: right;
}
.alert {
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// MyServices.vue?760e8970